import React from 'react';
import _ from 'lodash';
import '../css/regokas.css';
import Success from '../images/Success.svg';
import Error from '../images/Error.svg';
import Loader from '../components/loader';
import { connect } from 'react-redux';
import * as ActionTypes from '../actions/types';
import SnackBar from '../containers/SnackBar';
import Style from 'style-it';
import OrgChart from '../containers/userTreeMain';



class UserTreeChart extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            topHeightModal: '0%',
            okasBoxData: [],
            confirmWindow: false,
            kk: 'asdvhj',
            phone: '',
            name: '',
            selectedPermissions: {},
            email: '',
            officelocation: '',
            error: '',
            nameerror: '',
            namess: '',
            sortedType: '',
            searchValue: '',
            actualdata: [],
            disabledvalue: '',
            classshowofmodal: false,
            successmsgmodaldata: localStorage.getItem('dataadded'),
            showmodels: '',
            searchbar: '',
            opensearch1: 0,
            loader: '',
            currentPage: 1,
            todosPerPage: 10,
            statuste: false,
            indianCityWithState: [],
            showError: false,
            otherlocation: '',
            snackbarActive: false,
            snackbarMessage: '',
        };
        // this.handleClickpage = this.handleClickpage.bind(this);
    }

    confirmWindowClose = () => {
        this.props.backgroundScrollStop(!this.props.redux.globalVar.backgroundScrollStop);
        this.setState({
            confirmWindow: false
        })
    }

    opensearch = (data) => {
        if (data == 0)
            this.setState({
                opensearch1: 1,
            });
        else
            this.setState({
                opensearch1: 0,
            });
        // console.log(this.state.opensearch1)
    }

    componentDidMount() {
        this.getallrealdata();
       
    }

    //------------------------------------------------ error msg function start--------------------------------------------------------
    errormsg = () => {
        setTimeout(
            function () {
                localStorage.removeItem('dataadded');
                this.setState({
                    successmsgmodaldata: '',
                    error: '',
                })
            }
                .bind(this), 3000
        );
    }
    //------------------------------------------------ error msg function end ------------------------------------------------

    // ------------------------------------------------main data get API start------------------------------------------------
    getallrealdata = () => {
        this.setState({
            loader: true,
        })
        let TokenValue = 'Token ' + localStorage.getItem("auth");
        var headers = {
            'Content-Type': 'application/json',
            'Authorization': TokenValue,
            'X-CSRFToken': localStorage.getItem('csrftoken')
        }
        fetch('/we/addRoles/', {
            method: "GET",
            headers: headers
        })
            .then(response => response.json())
            .then(okasBoxData => {
                console.log(okasBoxData);
                this.setState({
                    okasBoxData,
                    actualdata: okasBoxData
                }, () => {
                    // this.renderTableData();
                })
                this.setState({
                    loader: false,
                })
                // console.log('okas office location:',this.state.actualdata)
            })

    }
    //------------------------------------------------ main data get API end------------------------------------------------


    handleClickpage(number) {
        this.setState({
            currentPage: number,
        });
    }

    crosssuccessfullmsg = () => {
        localStorage.removeItem('dataadded');
        this.setState({
            successmsgmodaldata: '',
        })
    }

    crosserrorfullmsg = () => {
        localStorage.removeItem('dataadded');
        this.setState({
            error: '',
            nameerror: '',
        })
    }

    onAddClickHandler(type) {
        const { name, selectedPermissions } = this.state;

        if (!name.trim()) {
            this.setState({ error: "Please enter a group name" });
            return;
        }

        const userEmail = localStorage.getItem("email"); // 👈 Make sure this is set during login

        const jsonData = {
            name,
            permissions: selectedPermissions,
            role_created_by: userEmail || "unknown",
        };

        // console.log("📦 Final JSON Data:", JSON.stringify(jsonData, null, 2));

        // 🔥 POST request to we/addRoles/
        fetch("/we/addRoles/", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-CSRFToken": localStorage.getItem("csrftoken"),

            },
            body: JSON.stringify(jsonData),
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {
                // console.log("✅ Group successfully added:", data);

                if (type === "add") {
                    this.setState({ name: "", selectedPermissions: {} });
                    this.onclosemodel();
                }

                // Optionally show a success message or toast
            })
            .catch((error) => {
                console.error("❌ Error adding role:", error);
            });
    }
    restoreData = (data) => {
        this.setState({
            okasBoxData: data,
        })
    }


    render() {
        return (
            <div className="selfcontainer"
                style={{
                    position: !this.props.redux.globalVar.backgroundScrollStop && this.props.windowWidth < 760 ? "fixed" : "absolute",
                    overflow: !this.props.redux.globalVar.backgroundScrollStop && this.props.windowWidth < 760 ? "hidden" : ""
                }}
            >
                <SnackBar open={this.state.snackbarActive} handleSnackbarClose={() => {
                    this.setState({
                        snackbarActive: false
                    })
                }} message={this.state.snackbarMessage} />
                {this.state.loader ? <Loader /> : null}
                {/* <div className="addregOkasButton">
                    <Box
                        component="a"
                        // href="#regiokasbox"
                        className="addregOkasButtonicon button-custom-height-size"
                        onClick={this.onopenmodel.bind(this)}
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            backgroundColor: "#f9f9f9",
                            color: "#94979a",
                            textTransform: "none",
                            padding: "10px 20px",
                        }}
                    >
                        <AiOutlinePlus size={30} style={{ marginRight: 8, color: "#15599F" }} />
                        <span className="hidden-xs hidden-sm button-color">ADD NEW USER ROLE</span>
                    </Box>
                    <div className="hidden-xs hidden-md  hidden-lg button-color sm-heading-btn">Add New User Role</div>
                </div> */}
                <div className="row">
                    <h3>Add New User</h3>
                    <h6 className="mb-3 mt-0" style={{ width: '50%' }}>View the organizational hierarchy and add new users by selecting their reporting manager. Easily manage roles, group assignments, and access permissions in your internal OKAS distributor network.</h6>
                    <div className={this.state.successmsgmodaldata ? 'successmsgbox' : 'successmsgbox successmsgboxnone'}  >
                        <div className="inblksuccfull"><img src={Success} /></div>
                        {/* <div className="inblksucc1">
                            SUCCESS !
                            <a className="successmsgcross"><RxCross2 size={20} onClick={(e) => { this.crosserrorfullmsg(this) }} /></a>
                        </div> */}
                    </div>
                    <OrgChart />
                </div>
            </div>
        );
    }
}


const mapStateToProps = state => {
    return {
        redux: state,
    };
};


const mapDispatchToProps = dispatch => {
    return {
        searchBarActivate: (data) => dispatch({ type: ActionTypes.SEARCHBAR, data: data }),
        searchBarStyleActivate: (data) => dispatch({ type: ActionTypes.SEARCHBARSTYLE, data: data }),
        successBarActivate: (data) => dispatch({ type: ActionTypes.SUCCESSBAR, data: data }),
        backgroundScrollStop: (data) => dispatch({ type: ActionTypes.SCROLLSTOP, data: data }),
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(UserTreeChart);
